module.exports = __webpack_public_path__ + "img/snow.0bb8cb16.svg";